export default __webpack_public_path__ + "55cd616c7589bbaae754363bd3619c4a.arrow-desktop.svg";